// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"1cadad82","208":"bb400249","272":"377c83f8","369":"b851030d","496":"377b4f2a","604":"3dda69af","656":"a13238ac","692":"f4ccd900","760":"f04ee819","940":"4e532544"}[chunkId] + ".chunk.js";
};